import { render, staticRenderFns } from "./listNotice.vue?vue&type=template&id=a658b56e&scoped=true&"
import script from "./listNotice.vue?vue&type=script&lang=js&"
export * from "./listNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a658b56e",
  null
  
)

export default component.exports